<template>
    <div  id="main" ref="main" >
        <router-view id="content"></router-view>
        <v-dialog />
        <modals-container />
    </div>
</template>
<script>
import { EventBus } from "../../javascripts/eventBus.js";
export default {
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
    },
    created() {
    },
    updated() {


    }
}
</script>